<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>상품 리스트</h2>
      </div>
      <div class="table-btn center-right">
        <div class="btn-renew" @click="refreshList">
          <button class="btn btn-40"><span><img src="/static/img/ico-renew@2x.png" alt=""></span></button>
        </div>
        <div v-if="company" class="btn-export-excel" @click="downloadExcel">
          <button class="btn btn-40" :disabled="downloading">
            <span v-if="!downloading"><img src="/static/img/ico_excel@2x.png" alt=""></span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
        <div v-if="company" class="btn-frige-register" @click="createProduct">
          <button class="btn btn-140"><span><img src="/static/img/ico-plus-white@2x.png" alt=""></span>상품 등록</button>
        </div>
        <div v-if="company" class="btn-frige-register" @click="openUploadExcelModal">
          <button class="btn btn-140"><span><img src="/static/img/ico-plus-white@2x.png" alt=""></span>엑셀 상품 등록</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <table>
        <tr class="header">
          <th>상품 ID</th>
          <th>상품 이름</th>
          <th>상품 영문 이름</th>
          <th>분류</th>
          <th>공급가격</th>
          <th>판매가격</th>
          <th>무게(g)</th>
          <th>유통기간(시)</th>
        </tr>

        <tbody v-if="loading === false && pagination.total > 0">
          <tr v-for="item in list" :key="item.productID" @click="goDetail(item)">
            <td>
              <!-- TODO <div>{{ item.productAlias }}</div> -->
              <div>{{ item.productID }}</div>
            </td>
            <td>
              <div>{{ item.productName }}</div>
            </td>
            <td>
              <div>{{ item.productEngName }}</div>
            </td>
            <td>
              <div>{{ item.productType }}</div>
            </td>
            <td>
              <div>{{ Number(item.supplyPrice).toLocaleString() }}</div>
            </td>
            <td>
              <div>{{ Number(item.salePrice).toLocaleString() }}</div>
            </td>
            <td>
              <div>{{ item.weight }}</div>
            </td>
            <td>
              <div>{{ item.expirePeriod }}</div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7">{{ loading ? '조회 중입니다.' : '조회 내역이 없습니다.' }}</td>
          </tr>
        </tbody>
      </table>

      <div class="pagination" v-if="pagination.total > 0">
        <span class="pagination-prev" @click="goPrev">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <span v-if="pagination.pageArray[0] > 1" @click="goPage(1)">1</span>
        <span v-if="pagination.pageArray[0] > 1" @click="jumpPrev">...</span>
        <span
          v-for="n in pagination.pageArray"
          :key="n"
          :class="n === pagination.page ? 'page-num current' : 'page-num'"
          @click="goPage(n)"
          >{{ n }}
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="jumpNext"
          >...
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="goPage(pagination.length)"
          >{{ pagination.length }}
        </span>

        <span class="pagination-next" @click="goNext">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <input
          type="number"
          v-model="pagination.input"
          @keyup.enter="goPage(Number(pagination.input))"
        />
      </div>
    </div>

    <UploadExcelModal
      v-if="modal"
      :company="company"
      @closeUploadExcelModal="closeUploadExcelModal"
      @createComplete="createComplete"
    ></UploadExcelModal>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop  */

import Configuration from '@/js/Configuration';
import js2excel from 'js2excel'; // https://github.com/dwqs/js2excel
import UploadExcelModal from '@/components/product/UploadExcelModal';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  components: {
    UploadExcelModal,
    ButtonLoading,
  },
  props: [
    'company',
    'tray',
    'searchCondition',
    'searchEvent',
  ],
  data: () => ({
    list: [],
    pagination: {
      page: 1,
      total: 0,
      length: 1,
      perPage: 10,
      perLength: 5,
      pageArray: [],
      input: 1,
    },
    loading: true,
    modal: false,
    downloadFileName: 'cella-product',
    downloading: false,
  }),
  created() {
    if (this.company || this.tray) {
      this.loadPagination();
      this.getList(false);
    }
  },
  watch: {
    searchEvent() {
      this.pagination.page = 1;
      this.pagination.input = 1;
      this.pagination.total = 0;
      this.pagination.length = 1;

      this.getList(false);
    },
  },
  methods: {
    refreshList() {
      this.getList(false);
    },
    savePagination() {
      let key;
      if (this.company) {
        key = this.company.id;
      } else if (this.tray) {
        key = this.tray.companyID;
      }
      const page = {
        [key]: this.pagination.page,
      };
      sessionStorage.setItem('pagination', JSON.stringify(page));
    },
    loadPagination() {
      let key;
      if (this.company) {
        key = this.company.id;
      } else if (this.tray) {
        key = this.tray.companyID;
      }
      const page = JSON.parse(sessionStorage.getItem('pagination'));
      if (page !== null && page[key] !== undefined) this.pagination.page = page[key];
    },
    async getList(forDownload) {
      this.savePagination();
      const list = [];
      let page = this.pagination.page;
      let perPage = this.pagination.perPage;

      if (!forDownload) {
        this.list = [];
        this.pagination.input = this.pagination.page;
      } else {
        page = 1;
        perPage = 500;
      }

      try {
        let countURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/product/count?test=dump`;
        if (this.company) {
          countURL += `&companyID=${this.company.id}`;
        } else if (this.tray) {
          countURL += `&companyID=${this.tray.companyID}`;
        }
        if (this.searchCondition) {
          countURL += `&${this.searchCondition}`;
        }
        const count = await this.$http.get(countURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (count.status !== 200) {
          throw new Error(`Response status is "${count.status}"`);
        }
        if (count.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${count.data.resultCode}"`);
        }
        if (count.data.count < 1) {
          this.pagination.page = 1;
          this.pagination.total = 0;
          this.pagination.length = 1;
          this.loading = false;
          this.$emit('selectProduct', null);
          return list;
        }

        this.pagination.total = count.data.count;
        this.pagination.length = Math.ceil(
          this.pagination.total / this.pagination.perPage,
        );

        const pageBack = Math.floor((this.pagination.perLength - 1) / 2);
        const pageForward = this.pagination.perLength - 1 - pageBack;
        let firstPage = this.pagination.page - pageForward;
        let lastPage = this.pagination.page + pageBack;
        if (firstPage < 1) {
          firstPage = 1;
          lastPage = this.pagination.perLength;
        }
        if (lastPage > this.pagination.length) {
          lastPage = this.pagination.length;
        }
        if (lastPage - firstPage + 1 < this.pagination.perLength) {
          if (firstPage > 1) {
            firstPage -= this.pagination.perLength - lastPage + firstPage - 1;
            if (firstPage < 1) {
              firstPage = 1;
            }
          } else if (lastPage < this.pagination.length) {
            lastPage += this.pagination.perLength - lastPage + firstPage - 1;
            if (lastPage > this.pagination.length) {
              lastPage = this.pagination.length;
            }
          }
        }

        this.pagination.pageArray = [];
        for (let i = firstPage; i <= lastPage; i++) {
          this.pagination.pageArray.push(i);
        }

        let num =
          this.pagination.total -
          (this.pagination.page - 1) * this.pagination.perPage;

        let listURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/product/list?page=${page}&limit=${perPage}`;
        if (this.company) {
          listURL += `&companyID=${this.company.id}`;
        } else if (this.tray) {
          listURL += `&companyID=${this.tray.companyID}`;
        }
        if (this.searchCondition) {
          listURL += `&${this.searchCondition}`;
        }
        const resList = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (resList.status !== 200) {
          if (resList.status === 204) {
            this.pagination.page = 1;
            this.pagination.total = 0;
            this.pagination.length = 1;
            this.loading = false;
            this.$emit('selectProduct', null);
            return list;
          }

          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }

        for (let i = 0; i < resList.data.products.length; i++) {
          const p = resList.data.products[i];
          p.num = num;

          //
          if (!p.companyName) {
            const company = await this.$getCompany(p.companyID, false, false);
            if (company) {
              p.companyName = company.companyName;
            }
          }
          if (!p.divisionName) {
            const division = await this.$getDivision(p.divisionID, false, false);
            if (division) {
              p.divisionName = division.divisionName;
            }
          }

          list.push(p);
          num--;
        }

        if (!forDownload) {
          this.list = list;
        }
        this.loading = false;
      } catch (e) {
        this.pagination.page = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;
        this.list = [];
        this.loading = false;

        alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
      return list;
    },
    goPrev() {
      if (this.pagination.page <= 1) {
        return;
      }
      this.pagination.page--;

      this.getList(false);
    },
    goNext() {
      if (this.pagination.page >= this.pagination.length) {
        return;
      }
      this.pagination.page++;

      this.getList(false);
    },
    jumpPrev() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[0];
        this.pagination.page--;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page < 1) {
        this.pagination.page = 1;
      }

      this.getList(false);
    },
    jumpNext() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[
          this.pagination.pageArray.length - 1
        ];
        this.pagination.page++;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page > this.pagination.length) {
        this.pagination.page = this.pagination.length;
      }

      this.getList(false);
    },
    goPage(page) {
      if (page < 1) {
        page = 1;
      }
      if (page > this.pagination.length) {
        page = this.pagination.length;
      }
      this.pagination.page = page;
      this.getList(false);
    },
    goDetail(product) {
      this.$emit('productDetail', product);
    },
    createProduct() {
      const company = {
        companyID: this.company.id,
        companyName: this.company.name,
        companyAlias: this.company.alias,
        registrationNo: this.company.registrationNo,
        scope: this.company.scope,
      };
      this.$emit('productCreate', company);
    },
    async downloadExcel() {
      try {
        this.downloading = true;
        const list = await this.getList(true);
        const products = [];
        if (list.length === 0) {
          const product = {
            productName: '',
            productEngName: '',
            productType: '',
            supplyPrice: 0,
            salePrice: 0,
            weight: 0.0,
            expirePeriod: 0,
            //
            companyID: this.company ? this.company.id : '',
            divisionID: '',
          };
          list.push(product);
        }
        for (let i = 0; i < list.length; i++) {
          const p = list[i];
          const product = {
            productName: p.productName,
            productEngName: p.productEngName,
            productType: p.productType,
            supplyPrice: parseInt(p.supplyPrice, 10),
            salePrice: parseInt(p.salePrice, 10),
            weight: parseFloat(p.weight),
            expirePeriod: parseInt(p.expirePeriod, 10),
            barcode: p.barcode,
            //
            companyID: p.companyID,
            divisionID: p.divisionID,
          };
          products.push(product);
        }
        js2excel.json2excel({
          data: products,
          name: this.downloadFileName,
          formateDate: 'yyyy/mm/dd',
        });
      } catch (e) {
        console.error('downloadExcel error', e);
      }

      this.downloading = false;

      /*
      // for webpack 3: dynamic import
      // webpackChunkName: "js2excel"
      import('js2excel').then(({ json2excel }) => {
        json2excel({
          data: this.list,
          name: this.downloadFileName,
          formateDate: 'dd/mm/yyyy',
        });
      }).catch((e) => {

      });
      */
    },
    openUploadExcelModal() {
      this.modal = true;
    },
    closeUploadExcelModal() {
      this.modal = false;
    },
    createComplete() {
      this.modal = false;
      this.getList(false);
    },
  },
};
</script>

<style scoped>
.product-list {
  margin-top: 28px;
}
.product-list .buttons {
  display:flex;
  float: right;
}
.product-list .buttons .btn {
  width: 100px;
  height: 30px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s;
  margin-bottom: 10px;
  margin-left: 10px;
  color: #ffffff;
  background-color: green;
}
.product-list .buttons .btn:disabled {
  background-color: #dedede !important;
  color: #ffffff !important;
  border: solid 1px #dedede !important;
  cursor: default;
}
.product-list .buttons .btn.hover {
  background-color: rgb(1, 148, 1);
}
.product-list .total {
  display: flex;
  margin-top: 25px;
  padding: 0 24px;
  width: 100%;
  height: 60px;
  background-color: #ffffff;
  border-radius: 2px;
  border: solid 1px #dee0e3;
  font-size: 12px;
  font-weight: bold;
  align-items: center;
  color: #707276;
}
.total .duration {
  display: flex;
  min-width: 300px;
  width: 300px;
  max-width: 300px;
}
.total .duration .time {
  display: flex;
  height: fit-content;
}
.total .duration .time :not(.date) {
  font-weight: normal;
}
.total .count {
  margin: 0 auto;
}
.product-list table {
  margin-top: 48px;
  width: 100%;
  text-align: center;
  border-collapse: collapse;
}
.product-list table tr {
  height: 75px;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.17px;
  color: #586063;
  border-bottom: solid 1px #dee0e3;
}
.product-list table tr.header {
  background-color: #ffffff;
  color: #b0bec5;
}
.product-list table tbody tr:hover {
  background-color:#dedede;
}
.product-list table th {
  border-right: solid 1px #dee0e3;
}
.product-list table td .time {
  font-weight: normal;
}
.pagination {
  padding: 20px 0;
  width: auto;
  height: 68px;
  text-align: center;
}
.pagination span {
  display: inline-block;
  margin-left: 12px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  text-align: center;
}
.pagination span.pagination-prev {
  margin-left: 0;
  padding: 4px;
}
.pagination span.pagination-prev img {
  height: 100%;
  transform: rotate(90deg);
  vertical-align: top;
}
.pagination span.pagination-next {
  padding: 4px;
}
.pagination span.pagination-next img {
  height: 100%;
  transform: rotate(-90deg);
  vertical-align: top;
}
.pagination span.page-num {
  font-weight: 500;
  line-height: 28px;
}
.pagination span.page-num.current {
  background-color: #263339;
  color: #fff;
  border-radius: 50px;
}
.pagination input[type="number"] {
  width: 28px;
  height: 100%;
  text-align: right;
  border-bottom: solid 1px #dee0e3;
}
.pagination input[type="number"]::-webkit-outer-spin-button,
.pagination input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.null {
  width: 100%;
  height: 75px;
  background-color: #ffffff;
}
.null-txt {
  margin: auto;
  margin-top: 6px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.17px;
  line-height: 75px;
}
</style>



// WEBPACK FOOTER //
// src/components/product/ProductList.vue